import { index, integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

import { baseColumns } from './baseColumns';

export const moodEntries = sqliteTable(
  'mood_entries',
  {
    ...baseColumns,
    mood: text('mood').notNull(), // 'angry' | 'sad' | 'happy' | 'laughing'
    timestamp: integer('timestamp').notNull() // Unix timestamp (ms)
  },
  (t) => [index('idx_mood_entries_timestamp').on(t.timestamp)]
);
